// components/InfoCard.jsx
import React from "react";
import { Card, CardActions, CardContent, CardMedia, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Simple card with title, body text, image and optional CTA button.
 * Props: { title, body, cta: { label, to }, image }
 */
export default function InfoCard({ title, body, cta, image }) {
  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {image && <CardMedia component="img" image={image} alt={title} sx={{ objectPosition: "top center", aspectRatio: "16 / 10" }} />}

      <CardContent sx={{ p: { xs: 2, sm: 2.5 }, pb: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {body}
        </Typography>
      </CardContent>

      {cta && (
        <CardActions sx={{ mt: "auto", pt: 0, pb: 2.5, px: { xs: 2, sm: 2.5 } }}>
          <Button
            size="small"
            variant="contained"
            component={RouterLink}
            to={cta.to}
            sx={{ alignSelf: "flex-start" }}
          >
            {cta.label}
          </Button>
        </CardActions>
      )}
    </Card>
  );
}
